<template>
    <div>
        <CCol sm="12">
            <CCard>
                <CCardBody class="d-flex flex-column">
                    <div class="d-flex flex-column">
                        <!-- Name -->
                        <div role="group" class="form-group col-12">
                            <label class=""> {{ $t('nameMandatory') }}</label>
                            <CInput v-model="group.name" :is-valid="genericValidator(group.name, attemptedSubmit) && errorValidator('Name')" :invalid-feedback="errorOutput['Name']"></CInput>
                        </div>
                    </div>
                    <!-- API errors that belong to no field above -->
                    <FormApiErrors :fields="['Name']"></FormApiErrors>
                    <!-- Action button + submitting -->  
                    <div role="group" class="form-group col-12 d-flex justify-content-end">
                        <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                        <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                    </div>
                    <!-- Loading -->
                    <FormLoading v-if="loading"></FormLoading>
                </CCardBody>
            </CCard>
        </CCol>
        <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
    </div>
</template>
     
<script>
import FormApiErrors from '@/controls/FormApiErrors.vue';
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import Group from "@/classes/Group";
import { mapState, mapActions } from 'vuex'
import LanguageDropdown from "@/controls/LanguageDropdown.vue";
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import FormLoading from '@/controls/FormLoading.vue'
import CustomPicker from '@/controls/CustomPicker.vue'
import InputGetList from "@/classes/InputGetList";
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

    export default {
    components: { FormApiErrors, LanguageDropdown, ConfirmationPopUp, FormLoading, CustomPicker, SingleOptionDropdown},
    props:{    
        baseGroup:
        {
            type: Object,
            default: null,
        }
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            group: new Group(),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage: "",
            loading: false,
        }
    },
    mounted: function()
    {
        this.loadCharacters();
        this.resetGroup();
    },
    computed:
    {
        ...mapState('characters', ['getCharactersOutput']),
        charactersInfo: function() {
            return this.getCharactersOutput ? this.getCharactersOutput : null;
        },
        characters: function()
        {
            var result = this.charactersInfo && this.charactersInfo.data ? this.charactersInfo.data : [];

            return result.map(x => { return { key: x.id.toString(), label: x.name } });
        },
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate required fields
            if(!this.group.name) { result['Name'] = this.$i18n.t("validateRequiredField"); }

            return result;
        },
        ...mapState('groups', ['putGroupOutput']),
        ...mapState('groups', ['postGroupOutput']),
    },
    methods:{
        ...mapActions('characters', ['getCharacters']),
        loadCharacters()
        {
            this.loading = true;
            this.getCharacters(new InputGetList(999, 1, '', 1, 'Name'));
        },
        resetGroup(){
            if(!this.baseGroup)
            {
                this.group = new Group();
                if(this.$route.query && this.$route.query.characterId)
                {
                    this.group.characterId = this.$route.query.characterId;
                }
            }
            else
            {
                this.group = deepClone(new Group, this.baseGroup);          
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;
            // Emit event
            if(this.group.isValid())
            {
                this.submitting = true;
                delete this.group.variations;
                this.$emit('submit-requested', this.group);
            }
        },
        genericValidator,
        errorValidator,
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "GroupsList" });
        },
    },
    watch:
    {
        putGroupOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        postGroupOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        baseGroup: function()
        {
            this.resetGroup();
        },
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        },
        characters: function(val)
        {
            this.loading = false;
        },
    }
}
</script> 
    
<style scoped>

    .showDropdown
    {
        display: block !important;
    }

    .input-group-append
    {
        height: fit-content;
    }

    img
    {
        width: 50%;
        height: 50%;
    }

</style> 